/**
 * @file 用户信息
 * @author lizhaoxia(lizhaoxia@baijiahulian.com)
 * @date 2019-07-08
 */

import {fetchUserInfo} from '../service/user';
import ls from '../utils/localStorage';

const USER_LS_KEY = 'yyUserInfo';

export default {
    state: {
        userInfo: null,
        isLogin: false,
    },

    action: {
        getUserInfo() {
            const userInfo = ls.get(USER_LS_KEY);

            if (userInfo) {
                return {
                    data: userInfo
                };
            }

            return fetchUserInfo();
        }
    },

    reducer: {
        getUserInfo(state, action, error) {
            if (!error) {

                const {data} = action.payload;

                // data && ls.set(USER_LS_KEY, data);

                // state.userInfo = data;
                // state.isLogin = !!data;

                // return state;

                return {
                    ...state,
                    userInfo: data,
                    isLogin: !!data,
                };
            }

            return {...state};
        }
    }
};
